import { useWebBooking } from "api/api-hooks/use-web-booking";
import getActivities from "components/selection-components/summary/activity-menu-pair";
import { useMemo } from "react";

function useActivityPrices() {
    const { data: webBooking } = useWebBooking();

    return useMemo(() => {
        const activities = webBooking ? getActivities(webBooking, webBooking.webBookingRules) : [];

        const totalPrice = activities.reduce(
            (sum, a) => sum + a.resourceTotalPrice + a.menuPrice,
            0
        );

        return { totalPrice };
    }, [webBooking]);
}

export { useActivityPrices };
